import { fetchAll } from './fetch';
import SavingPlan from 'models/savingPlan';

export default fetchAll('savingPlan', SavingPlan, []);
